import axios from "axios";
import API_URL from "./apiURL";


export const axiosClient = axios.create({
  baseURL: API_URL.master,
  headers: {
    'Accept': 'application/json',
    'Authorization': `Bearer ${API_URL.masterKey}`
  },
});

export const axiosRegister = axios.create({
  baseURL: API_URL.event,
  headers: {
    'Accept': 'application/json',
    'Authorization': `Bearer ${API_URL.regisToken}`
  },
});